import React from 'react'
import { Container, ScreenContainer, ScreenHeader, Button, EmptyState, Link } from "../components/wombat-ui";
import { PlusIcon } from '../components/icons';

import useTranslations from '../hooks/useTranslations'
import useViewer from "../hooks/useViewer";

import TemplateFormScreen from './TemplateFormScreen'
import { useBreadcrumbs } from '../hooks/useBreadcrumbs';

const NewTemplateScreen = () => {
  const t = useTranslations();

  const {
    isCapableOfInsertingTemplates,
  } = useViewer();

  useBreadcrumbs([
    {
      to: "/templates",
      text: t("templates.templates"),
    },
    {
      to: "/templates/new",
      text: t("templates.createTemplate"),
    },
  ]);

  return (
    <ScreenContainer
      error={
        !isCapableOfInsertingTemplates ? (
          <EmptyState
            title={t("network.unauthorized")}
            action={
              <Link variant="button" to="/">
                {t("network.backToHome")}
              </Link>
            }
          />
        ) : undefined
      }
    >
      <ScreenHeader
        title={t("templates.createTemplate")}
        icon={PlusIcon}
        actions={[
          <Button
            key="update"
            type="submit"
            form="templateForm"
          >
            {t("forms.actions.save")}
          </Button>,
        ]}
      />
      <Container>
        <TemplateFormScreen template={undefined} />
      </Container>
    </ScreenContainer>
  )
}

export default NewTemplateScreen;